import './_bootstrap';

/* CSS */
import '../css/app.css'
import '@splidejs/splide/css/core'
 
window.Alpine.start()